<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <h2>DNS A-records</h2>
        <template v-if="loading">
          <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
        </template>
        <template v-else>
          <p style="color: grey;">API rate limits: {{ rateReached }}/{{ rateLimits }} (per minute for one account)</p>
          <form @submit.prevent="save" action="" method="post">
            <p style="padding: 13px 15px; background: #ffebeb; display: inline-block; font-size: 17px;">
              <label>New IP:</label>
              <input style="padding: 3px 5px;" type="text" v-model="new_ip" required
                     pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$">
              <select v-model="account" name="account" required style="padding: 3px 5px;">
                <option></option>
                <option v-for="(item, key) in items" :value="key">{{ item.email }}</option>
              </select>
              <button type="submit">Submit</button>
            </p>
            <div v-for="(item, key) in items">
              <h3>{{ item.email }}</h3>
              <div v-for="(dns, domain) in item.dns">
                <h5 style="cursor: default;">{{ domain }}</h5>
                <p>
                  <label v-for="dnsItem in dns" style="background: #dcdcdc80; padding: 7px 10px; margin-right: 5px;">
                    <input v-model="dnsItem.selected" style="margin-right: 3px;" type="checkbox">{{ dnsItem.name }} - {{ dnsItem.data }}
                  </label>
                </p>
              </div>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loading: false,
      rateLimits: null,
      rateReached: null,
      items: [],
      new_ip: null,
      account: null,
      saveLoading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async save() {
      if (this.saveLoading) return;
      this.saveLoading = true;
      const {data} = await api.post('/new/projects/doip', {
        account: this.account,
        new_ip: this.new_ip,
        dns: Object.keys(this.items[this.account].dns).reduce((acc, dns) => {
          acc[dns] = this.items[this.account].dns[dns].reduce((acc, r) => {
            if (r.selected) {
              acc.push(r.id);
            }
            return acc;
          }, []);
          return acc;
        }, {})
      })
      if (data.success) {
        alert('Success!');
      } else {
        alert(data.error);
      }
      this.saveLoading = false;
    },
    async getData() {
      this.loading = true;
      const {data} = await api.index('/new/projects/doip')
      if (data.success) {
        this.rateLimits = data.rateLimits;
        this.rateReached = data.rateReached;
        this.items = Object.keys(data.items).reduce((acc, i) => {
          acc[i] = {
            ...data.items[i], dns: Object.keys(data.items[i].dns).reduce((acc, d) => {
              acc[d] = data.items[i].dns[d].map((r) => {
                return {...r, selected: false}
              });
              return acc;
            }, {})
          }
          return acc;
        }, {});
      } else {
        toastr['warning'](data.error);
      }
      this.loading = false;
    }
  }
}

</script>
